<!-- FILE GENERATED BY packages/components/design-tokens/build-scripts/generate-icons.js DO NOT CHANGE -->

<svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    data-token-name="IconAlert_16"
    viewBox="0 0 16 16"
    aria-hidden="true"
>
    <path
        fill="currentColor"
        fill-rule="evenodd"
        d="M9.348 2.557a1.555 1.555 0 0 0-2.692 0L1.27 11.884a1.555 1.555 0 0 0 1.346 2.332h10.77a1.555 1.555 0 0 0 1.346-2.332zm-1.343 9.907a.733.733 0 0 0 .73-.735.733.733 0 0 0-.73-.735h-.008a.733.733 0 0 0-.73.735c0 .406.326.735.73.735zm-.732-3.675c0 .406.328.735.732.735a.733.733 0 0 0 .73-.735V5.85a.733.733 0 0 0-.73-.735.733.733 0 0 0-.732.735z"
        clip-rule="evenodd"
    />
</svg>
